import {SettlementSettingsTypeEnum} from '@/services/api-clients';

export function settlementSettingIconFilter(settingType: SettlementSettingsTypeEnum): string {
  switch (settingType) {
    case SettlementSettingsTypeEnum.ServiceFee: return 'mdi-percent';
    case SettlementSettingsTypeEnum.PetrolVatRate: return 'mdi-gas-station';
    default: return '';
  }
}
